<template>
  <nav class="navbar is-black" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <figure class="image is-3by3">
        <img src="@/assets/milelogix_gold_black.png">
      </figure>
      <div
        class="navbar-burger"
        onclick="document.querySelector('.navbar-menu').classList.toggle('is-active');"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div id="navMenu" class="navbar-menu">
      <div class="navbar-end">
        <a @click="displayUploadCalendar" class="navbar-item">
          <i class="fas fa-2x fa-chart-pie" title="Generate Report"></i>
        </a>
        <a @click="displayUserPreferences" class="navbar-item">
          <i class="fas fa-2x fa-user-cog" title="User Preferences"></i>
        </a>
        <a @click="displayDocumentation" class="navbar-item">
          <i class="fas fa-2x fa-question-circle" title="Documentation"></i>
        </a>
        <a @click="logout" class="navbar-item">
          <i class="fas fa-2x fa-sign-out-alt" title="Sign out"></i>
        </a>
      </div>
    </div>
  </nav>
</template>


<script>
export default {
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    },
    displayUploadCalendar: function() {
      this.$emit("display-component", "upload");
    },
    displayUserPreferences: function() {
      this.$emit("display-component", "userPreferences");
    },
    displayDocumentation: function() {
      this.$emit("display-component", "documentation");
    }
  }
};
</script>


<style scoped>
.is-disabled {
  pointer-events: none;
  opacity: 1;
}
</style>
